import { FC } from "react"
import { NamedProps } from "react-select"
import CreatableSelect from "react-select/creatable"
import { useField } from "formik"
import { SelectOption } from "@interfaces/ui"

interface FormikSelectMultiProps extends NamedProps {
  name: string
  onChanges: (field: string, values: string[]) => void
}

export const FormikMultipleSelect: FC<FormikSelectMultiProps> = ({
  options,
  placeholder,
  name,
  onChanges,
}) => {
  const [field, meta] = useField(name)
  const errorText = meta.error

  const handleChange = (e: any) => {
    onChanges(
      name,
      e.map((item: SelectOption) => item.value)
    )
  }
  return (
    <>
      <CreatableSelect
        isMulti
        isClearable={false}
        hideSelectedOptions
        isSearchable
        placeholder={placeholder}
        options={options}
        onChange={handleChange}
        styles={{
          menu: (provided) => ({
            ...provided,
            padding: "4px 8px",
          }),
          menuList: (provided) => ({
            ...provided,
            maxHeight: "200px",
            "::-webkit-scrollbar": {
              width: "4px",
            },
            "::-webkit-scrollbar-track": {
              background: "#BDBDBD",
            },
            "::-webkit-scrollbar-thumb": {
              background: "#0DAD8E",
            },
            "::-webkit-scrollbar-thumb:hover": {
              background: "#0DAD8E",
            },
          }),
          option: (provided, state) => ({
            ...provided,
            color: state.isFocused ? "#FFFFFF" : "#979797",
            backgroundColor: state.isFocused ? "#0DAD8E" : "#FFFFFF",
            width: "98%",
          }),
          control: (provided: any, state) => ({
            ...provided,
            padding: "4px",
            border: `1px solid ${errorText ? "red" : "rgba(105, 105, 105, 0.3)"}`,
            boxShadow: state.isFocused ? 0 : 0,
            "&:hover": {
              border: `1px solid ${errorText ? "red" : "rgba(105, 105, 105, 0.3)"}`,
            },
          }),
          multiValue: (provided) => ({
            ...provided,
            color: "#FFFFFF",
            backgroundColor: "#0DAD8E",
            marginRight: 6,
            marginBottom: 4,
          }),
          multiValueLabel: (provided) => ({
            ...provided,
            color: "#FFFFFF",
          }),
          multiValueRemove: (provided) => ({
            ...provided,
            "&:hover": {
              color: "#FFFFFF",
              backgroundColor: "#0DAD8E",
            },
          }),
          dropdownIndicator: (provided) => ({
            ...provided,
            display: "none",
          }),
          indicatorSeparator: (provided) => ({
            ...provided,
            display: "none",
          }),
        }}
      />
      {errorText && <small className="text-red">{errorText}</small>}
    </>
  )
}
